const dispatch = (actionType, postData) => {
  MakeShiftEmployeeDispatcher.dispatch({ actionType, postData });
};

export default {
  // Closed and balancing blocks come back too, listed read-only while under review (MS-5709).
  // Published ones are left out, and so are ones whose period is long over, which keeps the list
  // bounded (MS-5710). The end date gets a day's slack for an employee whose clock runs ahead of
  // the department's; the store drops a block on its own department's calendar.
  getBlocks() {
    dispatch(appConstants.ActionTypes.GET_SELF_SCHEDULE_BLOCKS, {
      filter: {
        self_scheduling_block: {
          status: 'open,closed,balancing',
          block_end_date: { '(ge)': moment().subtract(1, 'day').format('YYYY-MM-DD') },
        },
      },
      sort: 'block_start_date',
    });
  },

  // Everything one block page needs, in one dispatch.
  getBlockData(blockId) {
    dispatch(appConstants.ActionTypes.GET_SELF_SCHEDULE_BLOCK_DATA, { blockId });
  },

  requestShift(blockId, shiftRequirementId) {
    dispatch(appConstants.ActionTypes.SELF_SCHEDULE_REQUEST_SHIFT, { blockId, shiftRequirementId });
  },

  cancelRequest(blockId, requestId) {
    dispatch(appConstants.ActionTypes.SELF_SCHEDULE_CANCEL_REQUEST, { blockId, requestId });
  },

  submit(blockId) {
    dispatch(appConstants.ActionTypes.SELF_SCHEDULE_SUBMIT, { blockId });
  },

  reopen(blockId) {
    dispatch(appConstants.ActionTypes.SELF_SCHEDULE_REOPEN, { blockId });
  },
};
